import React from 'react'

export default function Blog() {
  return (
    <div className='min-h-screen pt-[100px] text-white'>Blog</div>
  )
}
